import { Skeleton } from '@zorro/design-system/v2/Skeleton';

const TEXT_HEIGHT = 20;
const SELECTOR_HEIGHT = 90;

export const CardSelectorSkeleton = () => (
  <>
    <Skeleton height={TEXT_HEIGHT} w="200" />
    <Skeleton height={SELECTOR_HEIGHT} radius={8} />
  </>
);
